export default {
    name: 'soilDepth',
    serverName: '​/api/v1/rb_calculator/soil_sampling_depth/',
    apiUrl: '/api/v1/rb_calculator/soil_sampling_depth/'
};
